import { Field } from 'redux-form';
import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';

import SimpleCurrencyInput from './SimpleCurrency';
import { SHOP_CURRENCY } from '../main/shops/constants';
import withOverridableCurrency from './hoc/withOverridableCurrency';

const renderField = field => (
  <div className="u-position-relative">
    <div className="c-prefix" display-if={field.showPrefix}>{field.prefix}</div>
    <SimpleCurrencyInput
      precision={field.precision}
      onInputChange={(value) => {
        if (value !== field.input.value) {
          field.input.onChange(value);
        }
      }}
      value={field.input.value}
      className={classnames(
        field.className,
        {
          'c-input--prepend': field.showPrefix,
          'c-input--prepend-iso-currency': field.useIsoCurrencyCode,
        }
      )}
      placeholder={field.placeholder}
      onInputBlur={() => field.input.onBlur(field.input.value)}
      onInputFocus={field.input.onFocus}
      separator={field.separator}
      name={field.input.name}
      disabled={field.disabled}
    />
    {field.meta.touched && field.meta.error &&
    <div className="c-input-error-message">{field.meta.error}</div>}
  </div>
);

const CurrencyInput = ({ name, integer, ...attributes }) => {
  let props = attributes;
  if (integer) {
    props = {
      ...attributes,
      format: val => val / 100,
      parse: val => val * 100,
      precision: 0,
      separator: '',
    };
  }

  if (!props.prefix) {
    props.prefix = props.currencySymbol;

    if (props.useIsoCurrencyCode) {
      props.prefix = props.currency.toUpperCase();
    }
  }

  return (
    <Field
      name={name}
      component={renderField}
      {...props}
    />
  );
};

CurrencyInput.propTypes = {
  name: PropTypes.string.isRequired,
  currency: PropTypes.string,
  currencySymbol: PropTypes.string,
  integer: PropTypes.bool,
  prefix: PropTypes.string,
  showPrefix: PropTypes.bool,
  useIsoCurrencyCode: PropTypes.bool,
};

CurrencyInput.defaultProps = {
  currency: SHOP_CURRENCY.usd,
  currencySymbol: '$',
  integer: false,
  prefix: '',
  showPrefix: true,
  useIsoCurrencyCode: false,
};

export default withOverridableCurrency(CurrencyInput);
